/**
 * Where messages (toasts) sit on the screen. The app has two bars at the top: the header (h-16, 64 px) with the signed-in
 * name and the notification icons, and the page band under it (the page title and its buttons such as Send Invoice, about
 * 68 px). A toast pinned to the top right covered the signed-in name at 1440 wide (R4 reviewer, outside R4); just under
 * the header it would cover the page's own buttons instead. So on a wide screen the stack starts below both bars. On a phone
 * the bars wrap and take more room, so it keeps the small default offset there.
 */
export const HEADER_HEIGHT_PX = 64;
export const PAGE_BAND_HEIGHT_PX = 68;
export const TOAST_TOP_OFFSET_PX = HEADER_HEIGHT_PX + PAGE_BAND_HEIGHT_PX + 8;
export const TOAST_MOBILE_TOP_OFFSET_PX = 16;
